import { useQuery } from '@tanstack/react-query';
import compact from 'lodash/compact';

import { FilterBarChip } from '@/components/shared/FilterBar/types';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useScopeFilterChips from '@/data/hook/shared/useScopeFilterChips';
import { ExamPendenciesAdvancedFilters } from '@/data/hook/useExamPendenciesFilter';
import { courseBasesQueryKeys } from '@/data/services/querykeys';

type UseExamPendencyFilterChipsParams = {
  advancedFilters: ExamPendenciesAdvancedFilters;
};

export default function useExamPendencyFilterChips({
  advancedFilters,
}: UseExamPendencyFilterChipsParams): FilterBarChip[] {
  const scopeChips = useScopeFilterChips(advancedFilters);

  const { data: selectedCourse, isInitialLoading: isLoadingCourse } = useQuery({
    ...courseBasesQueryKeys.get(advancedFilters.course ?? 0),
    enabled: !!advancedFilters.course,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  return compact<FilterBarChip>([
    ...scopeChips,
    (selectedCourse || isLoadingCourse) && {
      key: 'course',
      label: selectedCourse?.abbreviation ?? '',
      isLoading: isLoadingCourse,
    },
  ]);
}
